// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Icon_iconContainer__9KNgk"};